module.exports = __webpack_public_path__ + "img/banner-2-2.051acd68.png";